// ConsoleLogger — default Logger impl for the web package.
//
// Matches `application/ports/Logger.ts` but routes to `console.*`. Phase 5+
// can swap in a Sentry-aware logger if needed (architecture.md §21).

import type { Logger, LogLevel } from '../../application/ports/Logger.js';

const ORDER: Record<LogLevel, number> = { debug: 0, info: 1, warn: 2, error: 3 };

export interface ConsoleLoggerOptions {
  level?: LogLevel;
}

export const createConsoleLogger = (opts: ConsoleLoggerOptions = {}): Logger => {
  const min = ORDER[opts.level ?? 'info'];
  return {
    debug(message, context) {
      if (min > ORDER.debug) return;
      // eslint-disable-next-line no-console
      console.debug(message, context ?? {});
    },
    info(message, context) {
      if (min > ORDER.info) return;
      // eslint-disable-next-line no-console
      console.info(message, context ?? {});
    },
    warn(message, context) {
      if (min > ORDER.warn) return;
      // eslint-disable-next-line no-console
      console.warn(message, context ?? {});
    },
    error(message, context) {
      // eslint-disable-next-line no-console
      console.error(message, context ?? {});
    },
  };
};
